import type { ReactNode } from 'react';
import { Button, Tooltip } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import FilledIconButton from './FilledIconButton';
import InfoButton from './InfoButton';

interface TabHeaderProps {
  title: string;
  description: string;
  addLabel?: string;
  onAdd?: () => void;
  addIcon?: ReactNode;
  addDisabled?: boolean;
}

export default function TabHeader({
  title,
  description,
  addLabel,
  onAdd,
  addIcon,
  addDisabled,
}: TabHeaderProps) {
  const icon = addIcon ?? <AddIcon />;
  const showAdd = !!onAdd && !!addLabel;
  return (
    <div className="flex items-center gap-0.5 mb-3">
      <h1 className="text-lg font-semibold">
        {title}
      </h1>
      <InfoButton title={title} description={description} />
      <div className="flex-1" />
      {showAdd && (
        <>
          <Tooltip title={addLabel}>
            <span role="group">
              <FilledIconButton
                onClick={onAdd}
                aria-label={addLabel}
                disabled={addDisabled}
                className="md:hidden"
              >
                {icon}
              </FilledIconButton>
            </span>
          </Tooltip>
          <Button
            variant="contained"
            startIcon={icon}
            onClick={onAdd}
            disabled={addDisabled}
            className="hidden md:inline-flex"
            data-testid="add-button"
          >
            {addLabel}
          </Button>
        </>
      )}
    </div>
  );
}
